import * as React from "react"
import {useEffect} from "react"
import {useComputed, useSignal} from "@preact/signals-react";
import {Box, Typography} from "@mui/material";
import {CountUpSeeker} from "@ui-seeker/core";
import {getSubmit} from "@ui-seeker/utils";

import NumItemsLoadingBlock from "./LoadingBlock";
import {BACKEND_APIS} from "@constants";
import {userData} from "@signals";


export default function MatchersNumItems({ version, isLoadedMoreItems=false }) {
	const numItems = useSignal(null)
	const isLoading = useSignal(true)
	const controller = useSignal(null)
	const haveController = useComputed(() => controller.value !== null)

	useEffect(() => {
		return () => {
			if (haveController.value) {
				controller.value.abort()
				controller.value = null
			}
		}
	}, [])

	useEffect(() => {
		if (isLoadedMoreItems || numItems.value === null) {
			if (haveController.value)
				controller.value.abort()
			controller.value = new AbortController()

			if (!isLoading.value)
				isLoading.value = true

			getSubmit(`${BACKEND_APIS.MATCHERS}/${version}/check-items-loaded/${userData.value.userID}`, {}, {
				signal: controller.value.signal
			}).then(res => {
				if (haveController.value)
					controller.value = null
				isLoading.value = false
				numItems.value = res.numItemsToMaping
			}).catch(() => {
				if (haveController.value)
					controller.value = null
				isLoading.value = false
			})
		}
	}, [isLoadedMoreItems])

	const getMappingType = () => {
		switch(version) {
			case 'reverse': return 'SKU → Product'
			case 'raw': return 'Product → SKU'
			case 'products': return 'Product → Product'
			default: return 'Direct SKU Mapping'
		}
	}
	const mappingType = getMappingType()

	return <Box display="flex" width={1} justifyContent="flex-end" gap={.5}>
		<Typography variant="h4">
			{mappingType} - Products Remaining:
		</Typography>

		{ isLoading.value
			? <NumItemsLoadingBlock />
			: <Typography variant="h4">
				<CountUpSeeker end={numItems.value}/>
			</Typography>
		}
	</Box>
}